// company master data printed in every report footer
const KEY = 'giss_company';
export const COMPANY_FIELDS = ['name', 'addr', 'phone', 'email', 'web'];
export const getCompany = () => { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; } };
export const setCompany = (c) => localStorage.setItem(KEY, JSON.stringify(c));
export const companyLine = (c = getCompany()) => [c.name, c.addr, c.phone && `Tel. ${c.phone}`, c.email, c.web].filter(Boolean).join(' · ');
